export default {"src":"https://images-cdn.curipod.com/d-bdb94e66/_next/static/media/lightbold.22c21651.svg","height":200,"width":200};